module.exports = __webpack_public_path__ + "images/emoji/tongue.226fd1c29cd5636e8fd6.png";